var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 3922"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check-circle-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.78921 0.825195C3.48735 0.825195 0 4.31254 0 8.61441C0 12.9163 3.48735 16.4036 7.78921 16.4036C12.0911 16.4036 15.5784 12.9163 15.5784 8.61441C15.5734 4.31462 12.089 0.830203 7.78921 0.825195Z",
    fill: "#4E2D92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.78921 0.825195C3.48735 0.825195 0 4.31254 0 8.61441C0 12.9163 3.48735 16.4036 7.78921 16.4036C12.0911 16.4036 15.5784 12.9163 15.5784 8.61441C15.5734 4.31462 12.089 0.830203 7.78921 0.825195Z",
    fill: "#4E2D92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.78921 0.825195C3.48735 0.825195 0 4.31254 0 8.61441C0 12.9163 3.48735 16.4036 7.78921 16.4036C12.0911 16.4036 15.5784 12.9163 15.5784 8.61441C15.5734 4.31462 12.089 0.830203 7.78921 0.825195Z",
    fill: "#4E2D92"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape_2",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.78921 0.825195C3.48735 0.825195 0 4.31254 0 8.61441C0 12.9163 3.48735 16.4036 7.78921 16.4036C12.0911 16.4036 15.5784 12.9163 15.5784 8.61441C15.5734 4.31462 12.089 0.830203 7.78921 0.825195Z",
    fill: "#4E2D92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.78921 0.825195C3.48735 0.825195 0 4.31254 0 8.61441C0 12.9163 3.48735 16.4036 7.78921 16.4036C12.0911 16.4036 15.5784 12.9163 15.5784 8.61441C15.5734 4.31462 12.089 0.830203 7.78921 0.825195Z",
    fill: "#4E2D92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.78921 0.825195C3.48735 0.825195 0 4.31254 0 8.61441C0 12.9163 3.48735 16.4036 7.78921 16.4036C12.0911 16.4036 15.5784 12.9163 15.5784 8.61441C15.5734 4.31462 12.089 0.830203 7.78921 0.825195Z",
    fill: "#4E2D92"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape_3",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.78921 0.825195C3.48735 0.825195 0 4.31254 0 8.61441C0 12.9163 3.48735 16.4036 7.78921 16.4036C12.0911 16.4036 15.5784 12.9163 15.5784 8.61441C15.5734 4.31462 12.089 0.830203 7.78921 0.825195Z",
    fill: "#4E2D92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.78921 0.825195C3.48735 0.825195 0 4.31254 0 8.61441C0 12.9163 3.48735 16.4036 7.78921 16.4036C12.0911 16.4036 15.5784 12.9163 15.5784 8.61441C15.5734 4.31462 12.089 0.830203 7.78921 0.825195Z",
    fill: "#4E2D92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.78921 0.825195C3.48735 0.825195 0 4.31254 0 8.61441C0 12.9163 3.48735 16.4036 7.78921 16.4036C12.0911 16.4036 15.5784 12.9163 15.5784 8.61441C15.5734 4.31462 12.089 0.830203 7.78921 0.825195Z",
    fill: "#4E2D92"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M12.2838 6.14786L7.84074 12.1774C7.73478 12.3179 7.57677 12.4101 7.40222 12.433C7.22768 12.456 7.05123 12.4078 6.91253 12.2994L3.73972 9.7627C3.45974 9.53865 3.41441 9.13005 3.63846 8.85007C3.86252 8.57009 4.27112 8.52475 4.5511 8.74881L7.19683 10.8655L11.2388 5.37997C11.3713 5.18108 11.6024 5.07112 11.8404 5.09374C12.0783 5.11637 12.2846 5.26792 12.3772 5.48822C12.4699 5.70853 12.434 5.96195 12.2838 6.14786Z",
    fill: "#4E2D92"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckPurple);
export default __webpack_public_path__ + "static/media/check_purple.ee2ff6865f47452ebcd39735da4c877c.svg";
export { ForwardRef as ReactComponent };